module.exports = __webpack_public_path__ + "img/77440.42a61769.svg";